import { Component, HostBinding, OnInit, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/api/dynamic-form/services';
import {
  ChildRouteInterface,
  RouteInterface,
} from 'src/app/shared/models/user.model';
import { RedirectService } from 'src/app/shared/services/redirect-service';

const BASE_CLASSES = 'main-sidebar elevation-4';

@Component({
  selector: 'app-sub-sidebar',
  templateUrl: './sub-sidebar.component.html',
  styleUrls: ['./sub-sidebar.component.scss'],
  standalone: false,
})
export class SubSidebarComponent implements OnInit {
  @HostBinding('class') classes: string = BASE_CLASSES;

  public menu = MENU;
  public loggedInUser = 'User Name';

  constructor(
    private userService: UserService,
    private toastr: ToastrService,
    private redirectService: RedirectService
  ) {}

  ngOnInit() {
    this.fetchLoggedInUser();
  }

  fetchLoggedInUser() {
    this.userService.getLoggedInUserDetails().subscribe({
      next: user => {
        if (user?.data) {
          this.loggedInUser = user?.data[0]?.name || '';
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }
  checkPermissions(item: RouteInterface): boolean {
    if (!item) {
      return false;
    }

    if (item.permissions) {
      const hasPermission = item.permissions.every((permission: string) =>
        this.redirectService.hasPermission(permission)
      );

      if (!hasPermission) {
        return false;
      }
    }

    if (item.children && item.children.length > 0) {
      const visibleChildren = item.children.filter(
        (child: ChildRouteInterface) => {
          return this.checkPermissions(child);
        }
      );

      item.children = visibleChildren;

      return visibleChildren.length > 0;
    }

    return true;
  }
}

export const MENU = [
  {
    name: 'Request Form',
    iconClasses: 'fa fa-users',
    path: ['/request-form'],
  },
];
